

let currentCountry = 'US';
let currentLang = 'en';


function submitForm(e, country, lang) {
  e.preventDefault();

  document.querySelectorAll('.Dropdown__Item ').forEach(function (item) {
    item.classList.remove('Active');
  });

  const hijo = e.target;
  var padre = hijo.parentNode;
  var wrapper = padre.parentNode;

  wrapper.classList.add('Active');

  currentCountry = country;
  currentLang = lang;

  
  

  if (hijo.classList.contains('Modal__Currency') || padre.classList.contains('Modal__Currency')) {
    const [countryext, mon, symbol] = extraerPartes(formatText(hijo.textContent));
    setCurrencyUI(countryext, mon, symbol, country.toLowerCase());
    window.Shopify.currency.active = mon;
    document.getElementById('country_code').value = currentCountry;
  }else{
    setLangUI(formatText(hijo.textContent));
    window.Shopify.locale = hijo.value;
    window.Shopify.country = hijo.value.toUpperCase();
    localStorage.setItem('ZDEV-currentLang', hijo.value);
    document.getElementById('locale_code').value = currentLang;
  }

}



function extraerPartes(cadena) {
    const simboloRegex = /[^a-zA-Z\s]/g;

    // Obtener las partes separando por el primer paréntesis encontrado
    const indiceParentesis = cadena.indexOf("(");
    const pais = cadena.slice(0, indiceParentesis).trim();

    // Obtener la parte que sigue al paréntesis (moneda y símbolo)
    const simboloMoneda = cadena.slice(indiceParentesis + 1).trim();

    let moneda; // Declarar `moneda` aquí para evitar el error de referencia
    let simbolo;

    // Separar la moneda del símbolo utilizando la expresión regular
    const simboloMatch = simboloMoneda.match(simboloRegex);
    if (simboloMatch) {
        simbolo = simboloMatch.join("");
        moneda = simboloMoneda.replace(simboloRegex, "");
    } else {
        moneda = simboloMoneda;
        simbolo = "";
    }

    simbolo = simbolo.replace(")", "");

    // Retornar un objeto con las partes
    return [pais, moneda, simbolo];
}


function formatText(texto) {
  // Reemplaza todas las secuencias de espacios en blanco por un solo espacio
  return texto.replace(/\s+/g, " ");
}


function setCurrencyUI(name, curr, sym , country) {
  var nombre = name
  var currency = curr
  var symbol = sym

  // Acceder al elemento span
  var span = document.querySelector('.CountrySelector__Context');
  var flag = document.querySelector('.ModalCountryFlag');

  if (flag) {
    flag.src = 'https://cdn.shopify.com/static/images/flags/' + country + '.svg?format=jpg&width=60';
  }

  const nameFormatted = name.replace(/[^a-zA-Z]/g, '');;

  if (nameFormatted.trim() === nameFormatted.trim().toUpperCase()) {
        // Verificar si se encontró el span
        if (span) {
          var contenidoSpan = nombre;
          // Construir el contenido del span
          var test = currency + ' ' + symbol;
          // Reemplazar el contenido del span con los valores extraídos
          span.innerHTML = test;
      } else {
          console.log("No se encontró el span correspondiente.");
      }
  }
  else {
        // Verificar si se encontró el span
        if (span) {
          var contenidoSpan = nombre;
          // Construir el contenido del span
          contenidoSpan += ' <span class="LanguageSelector__SeparatorLight">|</span> ' + currency + ' ' + symbol;
          // Reemplazar el contenido del span con los valores extraídos
          span.innerHTML = contenidoSpan;
      } else {
          console.log("No se encontró el span correspondiente.");
      }
  }


}

function setLangUI(lang) {
  // Acceder al elemento span
  var btn = document.querySelector('.LangSelector .Dropdown__MainText');
  
  // Verificar si se encontró el span
  if (btn) {
    btn.textContent = lang;
  }
}



document.addEventListener('DOMContentLoaded', function () {
  const modalSelector = document.querySelector('.modal-selector');
  const closeButton = document.querySelector('.modal-selector-close');
  const ButtonSubmit = document.querySelector('.modal-selector-submit--container');
 
  const hasAutoload = modalSelector.getAttribute('data-autoload');
 
  const localStorage = window.localStorage;
  if (!modalSelector) {
    return;
  }

  if (localStorage.getItem('ZDEV-modalLang') !== 'true' && hasAutoload == 'true') {
    modalSelector.classList.add('is-active');
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      modalSelector.classList.remove('is-active');
      localStorage.setItem('ZDEV-modalLang', 'true');
    });
  }

  if (ButtonSubmit) {
    ButtonSubmit.addEventListener('click', async function () {
      modalSelector.classList.remove('is-active');
      const boton = document.querySelector('.modal-selector-submit--container .modal-selector-submit');
      boton.value = currentCountry;
      localStorage.setItem('ZDEV-modalLang', 'true');
    });
  }
});

